import { DataTablePrimeReact, Dialog } from "@finanedi.es/storybook"
import { DevolucionReadingDtoProps } from "api/DTOs/DevolucionReadingDto"
import { DevolucionReadingFilteredDtoProps } from "api/DTOs/DevolucionReadingFilteredDto"
import {
  GetDevolucionesByFiltersParamsProps,
  devolucionesByFiltersCall,
  getDevolucionById,
  getDevolucionesByFilters,
} from "api/Devolucion.service"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import CustomButton from "common/components/Button/Button"
import Spinner from "common/components/Spinner"
import TesoreriaService from "common/services/TesoreriaService"
import { requestHandler } from "common/utils/utils"
import { DEFAULT_CURRENCY_SYMBOL } from "features/Contactos/constants"
import { ImporteBodyTemplate } from "features/Documentos/templates"
import NewDevolucionForm from "features/Tesoreria/components/NewDevolucionForm"
import NewRemesaForm from "features/Tesoreria/components/NewRemesaForm"
import { useDispatch } from "hooks/useDispatch"
import { useFilterMenu } from "hooks/useFilterMenu"
import { Suspense, lazy, useCallback, useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { getIdsFromDocumentos, getTotals } from "../Cartera/constants"
import { FilterMenu } from "./components/FilterMenu"
import DEVOLUCIONES_INGRESOS_COLUMNS from "./components/TableDevolucionesIngresos/DevolucionesIngresosColumns"
import DevolucionesIngresosTable from "./components/TableDevolucionesIngresos/DevolucionesIngresosTable"
import { getModalSetup, modificateDevolucionValues } from "./constant"
import "./style.scss"

const ActionToast = lazy(() => import("common/components/ActionToast"))
const DeleteModal = lazy(() => import("common/components/Modal/DeleteModal"))
const Modal = lazy(() => import("common/components/Modal/Modal"))

const DevolucionIngresos = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | 0 | -1 | null | undefined>(0)
  const [selection, setSelection] = useState<
    DevolucionReadingFilteredDtoProps[]
  >([])

  const [showDelete, setShowDelete] = useState<{
    data?: DevolucionReadingFilteredDtoProps | null
    status?: boolean
    modeDetails?: $TSMigrationFixMe
  }>({
    data: null,
    status: false,
    modeDetails: null,
  })
  const [showNewRemesa, setShowNewRemesa] = useState({
    data: null,
    status: false,
  })
  const [showCreateModal, setShowCreateModal] = useState<{
    data: DevolucionReadingDtoProps | null
    status: boolean
  }>({
    data: null,
    status: false,
  })
  const [sortingCriteria, setSortingCriteria] = useState<SortingCriteria>({
    sort: undefined,
    property: undefined,
  })
  const [pagination, setPagination] = useState({
    itemsPerPage: 100,
    skipCount: 0,
  })

  const fetchDevoluciones = useCallback(
    () => (queryParams: GetDevolucionesByFiltersParamsProps) => {
      devolucionesByFiltersCall?.cancel()
      return getDevolucionesByFilters({
        ...queryParams,
        SkipCount: queryParams.SkipCount ?? 0,
        SortingCriteria: queryParams.SortingCriteria,
        MaxResultCount: queryParams.MaxResultCount ?? 10,
      })
    },
    []
  )
  const { items, isLoading, totalCount, setServiceQuery, fetchTableData } =
    useFilterMenu({
      serviceCall: fetchDevoluciones,
    })

  const openEditModal = async (id: string) => {
    const response = await getDevolucionById(id)
    setShowCreateModal({ data: response, status: true })
  }
  const openDeleteModal = (rowData: DevolucionReadingFilteredDtoProps) => {
    setShowDelete({ data: rowData, status: true })
  }

  const handleOpenCreateModal = useCallback(
    (_: $TSMigrationFixMe, openModal: $TSMigrationFixMe) => {
      setShowCreateModal({ data: null, status: openModal })
    },
    []
  )

  const onRenderContent = useMemo(() => {
    return (
      <div className='tw-flex tw-justify-between'>
        <span className='tw-font-medium'>
          {t("devoluciones.toast.selectedLabel")} {selection?.length}
        </span>
        <span className='tw-flex tw-flex-row tw-gap-1 tw-font-medium'>
          {t("devoluciones.toast.totalLabel")}
          <ImporteBodyTemplate
            importe={getTotals(selection, "importe")}
            divisa={DEFAULT_CURRENCY_SYMBOL}
          />
        </span>
      </div>
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selection?.length])

  const handleHideToast = () => {
    setSelection([])
  }

  const onSucessActionDevolution = () => {
    setShowCreateModal({
      // @ts-expect-error TS(2345): Argument of type '{ id: null; status: false; }' is...
      id: null,
      status: false,
    })
    fetchTableData()
  }

  const handleDelete = async () => {
    requestHandler(
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      showDelete.data.id,
      TesoreriaService.deleteDevolucion,
      onSucessActionDevolution,
      `${t("devoluciones.msg.devolucDelExit")}`,
      null,
      null,
      null
    )
    setShowDelete({
      data: null,
      status: false,
      modeDetails: null,
    })
  }

  const modalDeleteSetup = getModalSetup(
    showDelete.status,
    setShowDelete,
    handleDelete,
    showDelete.modeDetails,
    t
  )

  const handleCreate = async (values: $TSMigrationFixMe) => {
    // @ts-expect-error TS(2554): Expected 7 arguments, but got 6.
    requestHandler(
      values,
      TesoreriaService.createDevolucion,
      onSucessActionDevolution,
      `${t("devoluciones.msg.devolucCreaExit")}`,
      null,
      null
    )
  }

  const handleEdit = async ({ data, id }: $TSMigrationFixMe) => {
    // @ts-expect-error TS(2554): Expected 7 arguments, but got 6.
    requestHandler(
      { data, id },
      TesoreriaService.editDevolucion,
      onSucessActionDevolution,
      `${t("devoluciones.msg.devolucEditExit")}`,
      null,
      null
    )
    setShowCreateModal({
      // @ts-expect-error TS(2345): Argument of type '{ id: null; status: false; }' is...
      id: null,
      status: false,
    })
  }

  const handleOpenNewRemesa = (isOpen: $TSMigrationFixMe) => {
    const totalValue = getTotals(selection, "importe")
    const documentIds = getIdsFromDocumentos(selection)
    setShowNewRemesa({
      // @ts-expect-error TS(2322): Type '{ total: $TSFixMe; facturasIds: $TSFixMe; }' is not as...
      data: {
        total: totalValue,
        facturasIds: documentIds,
      },
      status: isOpen,
    })
  }

  const handleRedirectToList = () => {
    history.push(ROUTES.REMESAS)
  }

  const onSuccessCreateRemesa = async () => {
    handleRedirectToList()
  }

  const handleCreateRemesa = async (values: $TSMigrationFixMe) => {
    const devValues = modificateDevolucionValues(values)
    // @ts-expect-error TS(2554): Expected 7 arguments, but got 6.
    requestHandler(
      devValues,
      TesoreriaService.createRemesaDevolucion,
      onSuccessCreateRemesa,
      `${t("devoluciones.msg.remesaExit")}`,
      null,
      null
    )
    setShowNewRemesa({ data: null, status: false })
  }

  const dtRef = useRef<DataTablePrimeReact<
    DevolucionReadingFilteredDtoProps[]
  > | null>(null)
  const handleResetPagination = () => {
    dtRef.current && dtRef.current?.resetScroll()
    setPagination({
      itemsPerPage: pagination.itemsPerPage,
      skipCount: 0,
    })
  }
  const onSort = ({
    sortField,
    sortOrder,
  }: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => {
    setSortingCriteria({
      property: sortField ?? undefined,
      sort: sortOrder === 1 ? "ASC" : sortOrder === -1 ? "DESC" : undefined,
    })
    setSortField(sortField)
    setSortOrder(sortOrder)
    handleResetPagination()
  }

  return (
    <section className='tw-bg-white tw-h-full tw-overflow-hidden'>
      <FilterMenu
        serviceQuery={setServiceQuery}
        sortingCriteria={sortingCriteria}
        maxResultCount={pagination.itemsPerPage}
        skipCount={pagination.skipCount}
        resetPagination={handleResetPagination}
        openCreateDevolucionModal={() =>
          setShowCreateModal({ data: null, status: true })
        }
      />
      <div className='tw-h-[calc(100%-80px)]'>
        <DevolucionesIngresosTable
          columns={DEVOLUCIONES_INGRESOS_COLUMNS(
            t,
            openEditModal,
            openDeleteModal
          )}
          dtRef={dtRef}
          items={items}
          isLoading={isLoading}
          totalCount={totalCount}
          pagination={pagination}
          setPagination={setPagination}
          sortField={sortField}
          sortOrder={sortOrder}
          selection={selection}
          setSelection={setSelection}
          onSort={onSort}
        />
      </div>

      <Suspense fallback={<Spinner />}>
        <ActionToast
          show={Boolean(selection?.length)}
          onHide={handleHideToast}
          content={onRenderContent}
          customButtons={
            <CustomButton
              className='tw-ml-2 !tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none tw-cursor-pointer'
              onClick={() => handleOpenNewRemesa(true)}
            >
              {t("devoluciones.toast.remittanceButton")}
            </CustomButton>
          }
        />
        <Dialog
          header={
            showCreateModal?.data?.id
              ? `${t("devoluciones.modal.editTitle")}`
              : `${t("devoluciones.modal.newTitle")}`
          }
          visible={showCreateModal.status}
          onHide={() => handleOpenCreateModal(null, false)}
          className='departaments-modal !tw-w-130'
          draggable
          baseZIndex={10}
          keepInViewport={false}
        >
          <NewDevolucionForm
            // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
            isEditView={Boolean(showCreateModal?.data?.id)}
            dispatch={dispatch}
            onHide={() => setShowCreateModal({ data: null, status: false })}
            handleCreate={handleCreate}
            handleEdit={handleEdit}
            data={showCreateModal.data}
            t={t}
          />
        </Dialog>
        <DeleteModal
          visible={modalDeleteSetup?.show}
          onHide={() =>
            modalDeleteSetup?.setShow({
              id: null,
              status: false,
              key: "",
            })
          }
          size='small'
          iconType={modalDeleteSetup?.image}
          buttonLabel={t("devoluciones.delete.confirmButton")}
          title={`${t("devoluciones.delete.deleteLabel")}${
            modalDeleteSetup?.title || ""
          }`}
          message={modalDeleteSetup?.msj}
          onCancel={() =>
            modalDeleteSetup?.setShow({
              id: null,
              status: false,
              key: "",
            })
          }
          onConfirm={() => modalDeleteSetup?.delete(showDelete.modeDetails)}
        />
        <Modal
          header={t("devoluciones.modal.newRemittanceTitle")}
          visible={showNewRemesa.status}
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
          onHide={() => handleOpenNewRemesa(null, false)}
          size='small'
        >
          <NewRemesaForm
            // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
            hideModal={() => handleOpenNewRemesa(null, false)}
            // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
            onHide={() => handleOpenNewRemesa(null, false)}
            handleCreate={handleCreateRemesa}
            // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'NewRemesaFo...
            data={showNewRemesa.data}
            t={t}
          />
        </Modal>
      </Suspense>
    </section>
  )
}

export default DevolucionIngresos
